import { render, staticRenderFns } from "./DisplayFormInput.vue?vue&type=template&id=12ae332f&"
import script from "./DisplayFormInput.vue?vue&type=script&lang=js&"
export * from "./DisplayFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports